<common-header [title]="title" [items]="items"></common-header>

<div class="content">
  <div class="container-fluid">
    <app-session-management-control></app-session-management-control>
  </div>
</div>
